import React from 'react'
import { Box, Typography } from '@mui/material'
import { brandColors } from '../Color/Color'

// Define the props interface
interface CustomBadgeProps {
  color: string
  outline?: boolean
  label: string
  width?: string | number
  size?: string
  startIcon?: React.ReactNode
  endIcon?: React.ReactNode
  rounded?: boolean
}

const CustomBadge: React.FC<CustomBadgeProps> = ({
  color,
  outline = false,
  label,
  width,
  size = '0.875rem',
  startIcon,
  endIcon,
  rounded = false,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2px 8px',
        borderRadius: rounded ? '10px' : '6px',
        fontSize: size,
        fontWeight: '500',
        textAlign: 'center',
        whiteSpace: 'nowrap',
        backgroundColor: outline ? 'transparent' : color,
        color: outline ? color : brandColors.white,
        border: outline ? `1px solid ${color}` : 'none',
        width,
      }}
    >
      {startIcon && (
        <Box
          sx={{ marginRight: '4px', display: 'flex', alignItems: 'center' }}
          justifyContent={'center'}
        >
          {startIcon}
        </Box>
      )}
      <Typography variant='body2' sx={{ fontSize: size, textAlign: 'center', flex: 1 }}>
        {label}
      </Typography>
      {endIcon && <Box sx={{ marginLeft: '4px', display: 'flex', alignItems: 'center' }}>{endIcon}</Box>}
    </Box>
  )
}

export default CustomBadge
